export const BlockSelectionState = Object.freeze({
	notSelected: 'not-selected',
	primarySelected: 'primary-selected',
	secondarySelected: 'secondary-selected',
	editContent: 'edit-content'
});
